export default defineNuxtRouteMiddleware(async (to, from) => {
  const nuxtApp = useNuxtApp()

  // Store the current and previous route in the app's global state
  nuxtApp._current_route = to
  nuxtApp._previous_route = from
})
